import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as Actions from "../actions/ClientDispatchApiActions";
import {showModalWindow, removeModalWindow} from "../actions/WindowActions";
import {Map} from "immutable";

function* requestCreateClientDispatch(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CreateClientDispatchWindow", {}, "Create Client Dispatch"));
  yield take([Actions.CREATE_CLIENT_DISPATCH.CANCEL, Actions.CREATE_CLIENT_DISPATCH.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreateClientDispatch() {
  yield takeLatest(Actions.REQUEST_CREATE_CLIENT_DISPATCH, requestCreateClientDispatch);
}

function* requestEditClientDispatch(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditClientDispatchWindow", {clientDispatchId: baseAction.clientDispatchId}, "Edit Client Dispatch"));
  yield take([Actions.EDIT_CLIENT_DISPATCH.CANCEL, Actions.EDIT_CLIENT_DISPATCH.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditClientDispatch() {
  yield takeLatest(Actions.REQUEST_EDIT_CLIENT_DISPATCH, requestEditClientDispatch);
}

function* requestAddPalletToClientDispatch(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddPalletToClientDispatchWindow", {clientDispatchId: baseAction.clientDispatchId}, "Add Pallet"));
  yield take([Actions.ADD_PALLET_TO_CLIENT_DISPATCH.CANCEL, Actions.ADD_PALLET_TO_CLIENT_DISPATCH.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddPalletToClientDispatch() {
  yield takeLatest(Actions.REQUEST_ADD_PALLET_TO_CLIENT_DISPATCH, requestAddPalletToClientDispatch);
}

function* requestAddManualPalletToClientDispatch(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddManualPalletToClientDispatchWindow", {clientDispatchId: baseAction.clientDispatchId}, "Add Ad-hoc Pallet", Map({width: "60vw"})));
  yield take([Actions.ADD_MANUAL_PALLET_TO_CLIENT_DISPATCH.CANCEL, Actions.ADD_MANUAL_PALLET_TO_CLIENT_DISPATCH.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddManualPalletToClientDispatch() {
  yield takeLatest(Actions.REQUEST_ADD_MANUAL_PALLET_TO_CLIENT_DISPATCH, requestAddManualPalletToClientDispatch);
}

function* requestRemovePalletFromClientDispatch(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemovePalletFromClientDispatchWindow", {clientDispatchId: baseAction.clientDispatchId, palletId: baseAction.palletId}, "Remove Pallet"));
  yield take([Actions.REMOVE_PALLET_FROM_CLIENT_DISPATCH.CANCEL, Actions.REMOVE_PALLET_FROM_CLIENT_DISPATCH.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemovePalletFromClientDispatch() {
  yield takeLatest(Actions.REQUEST_REMOVE_PALLET_FROM_CLIENT_DISPATCH, requestRemovePalletFromClientDispatch);
}

function* requestShipClientDispatch(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ShipClientDispatchWindow", {clientDispatchId: baseAction.clientDispatchId}, "Ship Client Dispatch"));
  yield take([Actions.SHIP_CLIENT_DISPATCH.CANCEL, Actions.SHIP_CLIENT_DISPATCH.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestShipClientDispatch() {
  yield takeLatest(Actions.REQUEST_SHIP_CLIENT_DISPATCH, requestShipClientDispatch);
}

function* requestAddSerialsToClientDispatch(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddSerialsToClientDispatchWindow", {clientDispatchId: baseAction.clientDispatchId}, "Add Serial Numbers"));
  yield take([Actions.ADD_SERIALS_TO_CLIENT_DISPATCH.CANCEL, Actions.ADD_SERIALS_TO_CLIENT_DISPATCH.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddSerialsToClientDispatch() {
  yield takeLatest(Actions.REQUEST_ADD_SERIALS_TO_CLIENT_DISPATCH, requestAddSerialsToClientDispatch);
}

function* requestSyncClientDispatchWithStord(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SyncClientDispatchWithStordWindow", {clientDispatchId: baseAction.clientDispatchId}, "Check Stord"));
  yield take([Actions.SYNC_CLIENT_DISPATCH_WITH_STORD.CANCEL, Actions.SYNC_CLIENT_DISPATCH_WITH_STORD.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestSyncClientDispatchWithStord() {
  yield takeLatest(Actions.REQUEST_SYNC_CLIENT_DISPATCH_WITH_STORD, requestSyncClientDispatchWithStord);
}

function* requestCancelClientDispatch(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CancelClientDispatchWindow", {clientDispatchId: baseAction.clientDispatchId}, "Cancel Client Dispatch"));
  yield take([Actions.CANCEL_CLIENT_DISPATCH.CANCEL, Actions.CANCEL_CLIENT_DISPATCH.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCancelClientDispatch() {
  yield takeLatest(Actions.REQUEST_CANCEL_CLIENT_DISPATCH, requestCancelClientDispatch);
}

export default function* saga() {
  yield fork(watchRequestCreateClientDispatch);
  yield fork(watchRequestEditClientDispatch);
  yield fork(watchRequestAddPalletToClientDispatch);
  yield fork(watchRequestAddManualPalletToClientDispatch);
  yield fork(watchRequestRemovePalletFromClientDispatch);
  yield fork(watchRequestShipClientDispatch);
  yield fork(watchRequestAddSerialsToClientDispatch);
  yield fork(watchRequestSyncClientDispatchWithStord);
  yield fork(watchRequestCancelClientDispatch);
}
